import { render, staticRenderFns } from "./CelularDetalhadoImagem.vue?vue&type=template&id=1331ca2f&scoped=true&"
import script from "./CelularDetalhadoImagem.vue?vue&type=script&lang=js&"
export * from "./CelularDetalhadoImagem.vue?vue&type=script&lang=js&"
import style0 from "./CelularDetalhadoImagem.vue?vue&type=style&index=0&id=1331ca2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331ca2f",
  null
  
)

export default component.exports